import {
  type DomainAccessControlConfig,
  type DomainAccessControlConfigItem,
} from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const productsViewWarehouseAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.ProductsViewPage],
}

export const productsViewInternalAccessControl: DomainAccessControlConfig = {
  permissions: Permission.InstacartInternal,
}

export const productsViewVBOAccessControl: DomainAccessControlConfig = {
  permissions: productsViewInternalAccessControl.permissions,
}

export const productsViewAccessControl: DomainAccessControlConfig = [
  productsViewWarehouseAccessControl,
  productsViewInternalAccessControl,
] as DomainAccessControlConfigItem[]

export const productsViewItemAnomalyAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ItemAnomalyView,
}

export const CatalogProductsViewAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ProductsCatalogProductsView,
}

export const CatalogProductsModifyAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ProductsCatalogProductsModify,
}

export const productsViewInAssortmentAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ProductAttributesEdit,
}

export const collectionV2AccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ProductsRetailerCollectionsV2],
  warehouseFeatureToggles: [FeatureToggle.RetailerCollectionsV2],
}

export const sproutsTempOverrideEnabled: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.SproutsTempOverrideEnabled],
}

export const internalAdminTempOverrideEnabled: DomainAccessControlConfig = {
  permissions: productsViewInternalAccessControl.permissions,
  warehouseFeatureToggles: [FeatureToggle.InternalAdminTempOverrideEnabled],
}

export const showRetailerLabelsOnlyOnStorefrontPro: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.ProductsViewPageShowRetailerLabelsOnlyOnStoreFrontPro],
}

export const productViewPageShowLegacyEdit: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.ProductViewPageShowLegacyEdit],
}

export const productsViewMissingCodesAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.CatalogProductsView,
    warehouseFeatureToggles: [FeatureToggle.ForcemarksMissingCodes],
  },
  {
    permissions: Permission.PackagesDashboardCatalogProductsView,
    warehouseFeatureToggles: [FeatureToggle.ForcemarksMissingCodes],
  },
  {
    permissions: Permission.ProductsCatalogProductsView,
    warehouseFeatureToggles: [FeatureToggle.ForcemarksMissingCodes],
  },
]

export const productsViewLowPriceAlertsAccessControl: DomainAccessControlConfig = {
  // TODO: switch to product view access control when released to retailers
  permissions: productsViewInternalAccessControl.permissions,
  warehouseFeatureToggles: [FeatureToggle.ProductsViewLowPriceAlerts],
}
